import React, { useEffect, useState } from "react";
import styles from "./history.module.scss";
import Table, { column } from "../../components/Table";
import { status } from "./types";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import PaymentTable from "./payment.table";
import { toast } from "sonner";
import { ClipLoader } from "react-spinners";

export interface IWithdrawal {
  withdrawalId: string;
  userId: string;
  amount: number;
  status: string;
  paymentMethodId: string;
  paymentDetails: {
    isPrimary: boolean;
    payoneerId: string;
  };
  createdAt: string;
  teacherProfileId: string;
  firstName: string;
  lastName: string;
  otherNames: string;
  email: string;
}

function formatToUSD(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

const Paymenthistory = () => {
  interface tableData {
    amount: number;
    createdAt: string;
    email: string;
    status: status;
  }

  interface BaseApiResponse<T> {
    statusCode: number;
    status: string;
    message: string;
    result: T;
  }

  interface IPendingRequestCount extends BaseApiResponse<number> {}
  interface ITotalPaidCount extends BaseApiResponse<number> {}
  interface WithdrawalApiResponse extends BaseApiResponse<IWithdrawal[]> {}

  const [pendingCount, setPendingCount] = useState<IPendingRequestCount>();
  const [earnCount, setEarningCount] = useState<IPendingRequestCount>();
  const [isLoading, setLoading] = useState<boolean>(false);
  const [teacherWithdrawals, setTeacherWithdrawals] =
    useState<WithdrawalApiResponse>();
  const [totalPaid, setTotalPaid] = useState<ITotalPaidCount>();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = await localStorage.getItem("token");
        const role = await localStorage.getItem("Role");
        const baseUrl =  role === "partner" ? `${API_URL}/withdrawal/partners` : `${API_URL}/withdrawal/teachers`;
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const [pendingRes, totalEarning, withdrawalsRes, paidRes] =
          await Promise.all([
            axios.get(`${baseUrl}/pending/count`, config),
            axios.get(`${baseUrl}/total-earning`, config),
            axios.get(`${baseUrl}`, config),
            axios.get(`${baseUrl}/total-paid`, config),
          ]);

        setPendingCount(pendingRes.data);
        setTeacherWithdrawals(withdrawalsRes.data);
        setEarningCount(totalEarning.data);
        setTotalPaid(paidRes.data as ITotalPaidCount);
      } catch (error) {
        toast.error("Apologies, there was an error fetching payment history.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const column: column<tableData>[] = [
    {
      header: "Amount",
      id: "amount",
    },
    {
      header: "Request Date",
      id: "createdAt",
    },
    {
      header: "Email",
      id: "email",
    },
    {
      header: "Status",
      id: "status",
    },
  ];

  const [search, setSearch] = useState<string>("");
  return (
    <div className={styles.hbody}>
      <div className={styles.bdxt}>
        <p className={styles.payHistory}>Payment History</p>
        <div className={styles.analytics}>
          <div className={styles.total}>
            <p>Total Earnings</p>
            {isLoading ? (
              <p className={styles.balanceLoader}>
                <ClipLoader />
              </p>
            ) : (
              <h2>{formatToUSD(earnCount?.result ?? 0)}</h2>
            )}
          </div>
          <div className={styles.boxss}>
            <div className={styles.taw}>
              <p>Total Amount Withdrawn</p>
              {isLoading ? (
                <p className={styles.balanceLoader}>
                  <ClipLoader />
                </p>
              ) : (
                <h2>{formatToUSD(totalPaid?.result ?? 0)}</h2>
              )}
            </div>

            <div className={styles.taw}>
              <p>Pending Withdrawal Request</p>
              {isLoading ? (
                <p className={styles.balanceLoader}>
                  <ClipLoader />
                </p>
              ) : (
                <h2>{pendingCount ? pendingCount.result : 0}</h2>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.tablesection}>
        {isLoading ? (
          <p className={styles.balanceLoader}>
            <ClipLoader />
          </p>
        ) : (
          <>
            <p className={styles.trHead}>Transaction List</p>
            <PaymentTable
              data={teacherWithdrawals?.result as []}
              columns={column}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Paymenthistory;
